import axios from 'axios';

const bannedContentService = {
	list: async () => axios.get(`${process.env.OMZ_ZAPI}/admin/banned_contents`).then(result => result.data)
};

export default bannedContentService;
